import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * useJobsStore
 *
 * Zustand store that mirrors all JobDataContext state.
 * V2 components subscribe to specific slices via selectors so they only
 * re-render when the exact piece of state they care about changes.
 *
 * V1 backward-compat: JobsDataContext syncs every setter into this store,
 * so V1-authored state changes are immediately visible to V2 consumers.
 */
const useJobsStore = create(
  devtools(
    (set, get) => ({
      // ── State ────────────────────────────────────────────────────────────
      selectedJob: null,
      isDrawerOpen: false,
      selectedJdTab: 'job-description',
      pendingJdId: '',
      jdActionSelection: '',
      reviseJdProgress: false,
      compareViewSelection: '',
      jobData: [],
      viewByJobCodeOrRequisitionNumber: "requisition-number", // "job-code" or "requisition-number"

      // ── Actions ──────────────────────────────────────────────────────────
      setSelectedJob: (job) =>
        set({ selectedJob: job }, false, 'setSelectedJob'),

      setIsDrawerOpen: (open) =>
        set({ isDrawerOpen: open }, false, 'setIsDrawerOpen'),

      toggleDrawer: () =>
        set(
          (state) => ({ isDrawerOpen: !state.isDrawerOpen }),
          false,
          'toggleDrawer',
        ),

      handleBack: (create = false) => {
        set({ selectedJob: null }, false, 'handleBack');
        if (create === true) {
          get().toggleDrawer();
        }
      },

      setSelectedJdTab: (tab) =>
        set({ selectedJdTab: tab }, false, 'setSelectedJdTab'),

      setPendingJdId: (id) =>
        set({ pendingJdId: id }, false, 'setPendingJdId'),

      setJdActionSelection: (sel) =>
        set({ jdActionSelection: sel }, false, 'setJdActionSelection'),

      setReviseJdProgress: (val) =>
        set({ reviseJdProgress: val }, false, 'setReviseJdProgress'),

      setCompareViewSelection: (val) =>
        set({ compareViewSelection: val }, false, 'setCompareViewSelection'),

      setJobData: (data) =>
        set({ jobData: data }, false, 'setJobData'),

      setViewByJobCodeOrRequisitionNumber: (val) =>
        set({ viewByJobCodeOrRequisitionNumber: val }, false, 'setViewByJobCodeOrRequisitionNumber'),
    }),
    { name: 'Jobs Store', anonymousActionType: 'jobs' },
  ),
);

export default useJobsStore;
